import { computed } from 'vue';
import { controllerModel, type ticketDetails } from 'shared';

interface FareFlightDetailsBottomSheetParams extends Record<string, unknown> {
  flights: ticketDetails.types.MappedFlight[];
}

export function useFareFlightDetailsBottomSheet() {
  const bottomSheet = controllerModel.useBottomSheet();
  const bottomSheetName = 'fare-flight-details-bottom-sheet';

  return {
    name: bottomSheetName,
    show: (params: FareFlightDetailsBottomSheetParams) =>
      bottomSheet.show(bottomSheetName, params),
    hide: () => bottomSheet.hide(bottomSheetName),
    params: computed(
      () =>
        bottomSheet.getParams(
          bottomSheetName,
        ) as FareFlightDetailsBottomSheetParams,
    ),
  };
}
